<div class="manufacturer-grid-wrapper">
  <kendo-grid
    class="manufacturer-grid"
    [kendoGridBinding]="Order"
    [rowHeight]="rowHeight"
    [height]="gridHeight"
    [pageSize]="pageSize"
    scrollable="virtual"
    [navigable]="false"
    [sortable]="false"
    [reorderable]="false"
    [resizable]="false"
  >
    <kendo-grid-column
      [width]="190"
      field="order_number"
      title="N&#176; ordine"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="manufacturer-cell-value manufacturer-cell-value--order">
          {{ dataItem.order_number }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="180"
      field="order_date"
      title="Data ordine"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="manufacturer-cell-value manufacturer-cell-value--date">
          {{ dataItem.order_date | date: "dd/MM/yy" }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="270"
      field="delivery_date"
      title="Data prevista evasione"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="manufacturer-cell-value manufacturer-cell-value--date">
          {{ dataItem.delivery_date | date: "dd/MM/yy" }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="140"
      field="product_count"
      title="N&#176; articoli"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="manufacturer-cell-value manufacturer-cell-value--articles">
          {{ formatArticleCount(dataItem.product_count) }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column
      title="Processa"
      [width]="110"
      [headerStyle]="{ 'justify-content': 'center' }"
      [style]="{ 'text-align': 'center' }"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <button
          type="button"
          class="manufacturer-icon-button manufacturer-icon-button--process"
          title="Processa ordine"
          (click)="openOrder(dataItem)"
        >
          <i class="bx bx-alert-triangle"></i>
        </button>
      </ng-template>
    </kendo-grid-command-column>

    <ng-template kendoGridNoRecordsTemplate>
      <div class="manufacturer-empty-state">
        <p>Nessun ordine disponibile per questa vista.</p>
      </div>
    </ng-template>
  </kendo-grid>
</div>
